module.exports = __webpack_public_path__ + "static/img/10.4f04cc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/10.png
// module id = fDBV
// module chunks = 0